import {
  JourneyNodeId,
  JourneyNodeStatus,
  JourneyNodeTone,
  type JourneyNode,
} from './journeyFlowModel';
import { formatPercent, numberFormat } from '../../../../../../lib/format';
import { dashboardT } from '../../../../../../lib/messages';
const toneColors: Record<JourneyNodeTone, string> = {
  [JourneyNodeTone.Primary]: 'var(--primary)',
  [JourneyNodeTone.Success]: 'var(--positive)',
  [JourneyNodeTone.Warning]: 'var(--status-report-text)',
  [JourneyNodeTone.Error]: 'var(--destructive)',
  [JourneyNodeTone.Muted]: 'var(--muted-foreground)',
  [JourneyNodeTone.Undefined]: 'var(--status-neutral-text)',
};
const nodeColors: Partial<Record<JourneyNodeId, string>> = {
  [JourneyNodeId.BidRequests]: '#6366f1',
  [JourneyNodeId.BidResponses]: '#4fd1c5',
  [JourneyNodeId.NoBids]: '#e5ec55',
  [JourneyNodeId.BidTimeouts]: '#a78bfa',
  [JourneyNodeId.ConnectionErrors]: '#f87171',
  [JourneyNodeId.InvalidBids]: '#fb923c',
  [JourneyNodeId.ValidBids]: '#34d399',
  [JourneyNodeId.BidResponseErrors]: '#f472b6',
  [JourneyNodeId.UnwrapErrors]: '#fbbf24',
  [JourneyNodeId.BidWon]: '#f59e0b',
  [JourneyNodeId.BidLost]: '#a78bfa',
  [JourneyNodeId.BidRejected]: '#84cc16',
  [JourneyNodeId.Impressions]: '#fb923c',
  [JourneyNodeId.NoImpressions]: '#d946ef',
};

export function journeyNodeColor(node: JourneyNode): string {
  if (node.status === JourneyNodeStatus.Unavailable) return toneColors[JourneyNodeTone.Muted];
  return nodeColors[node.id] ?? toneColors[node.tone];
}
export function journeyCountLabel(node: JourneyNode): string {
  return node.status === JourneyNodeStatus.Unavailable
    ? dashboardT('journey.unavailable')
    : numberFormat().format(node.count);
}

export function journeyPercentageLabel(
  node: Pick<JourneyNode, 'count'>,
  percentage: number,
): string {
  if (node.count > 0 && percentage >= 0 && percentage < 0.01) return '<0.01%';
  return formatPercent(percentage);
}
